import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QueryType } from '../../types/QueryTypes';
import { BenchmarkQuestion } from './types';

export interface BenchmarkState {
  questions: BenchmarkQuestion[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  filters: {
    query_type?: QueryType;
    user_persona?: string;
  };
}

const initialState: BenchmarkState = {
  questions: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  filters: {
    query_type: undefined,
    user_persona: undefined,
  },
};

const benchmarkSlice = createSlice({
  name: 'benchmark',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setQueryTypeFilter: (state, action: PayloadAction<QueryType | undefined>) => {
      state.filters.query_type = action.payload;
      state.page = 1;
    },
    setUserPersonaFilter: (state, action: PayloadAction<string | undefined>) => {
      state.filters.user_persona = action.payload;
      state.page = 1;
    },
    setBenchmarkData: (
      state,
      action: PayloadAction<{ data: BenchmarkQuestion[]; total: number }>,
    ) => {
      state.questions = action.payload.data;
      state.total = action.payload.total;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.page = 1;
    },
    updateQuestion: (state, action: PayloadAction<BenchmarkQuestion>) => {
      const index = state.questions.findIndex((q) => q.id === action.payload.id);
      if (index !== -1) {
        state.questions[index] = action.payload;
      }
    },
    deleteQuestion: (state, action: PayloadAction<string>) => {
      state.questions = state.questions.filter((q) => q.id !== action.payload);
      state.total -= 1;
    },
  },
});

export const {
  setLoading,
  setError,
  setPage,
  setQueryTypeFilter,
  setUserPersonaFilter,
  setBenchmarkData,
  resetFilters,
  updateQuestion,
  deleteQuestion,
} = benchmarkSlice.actions;

export default benchmarkSlice.reducer;
